export const transformData = (data) =>
  data.map((item) => ({
    metadata: {
      id: item.id,
      url: item.permalink,
    },
    pictures: {
      pictures: [{ id: item.thumbnail_id }],
      size: 'W',
    },
    bookmark: {
      alt_text: 'boton favorito',
      bookmarked: false,
    },
    components: [
      {
        type: 'title',
        title: { text: item.title },
      },
      {
        type: 'price',
        price: {
          current_price: {
            value: Number(item.price),
            currency: item.currency_id,
            decimal_style: 'superscript',
          },
        },
      },
      {
        type: 'attributes_list',
        attributes_list: {
          texts: [
            `${item.vehicle_year || 'N/A'}`,
            `${item.kilometers || 'N/A'}`,
          ],
          separator: '|',
        },
      },
      {
        type: 'location',
        location: { text: `${item.city_name} - ${item.state_name}` },
      },
    ],
  }));

export const generatePolycardContext = (isMobile) => ({
  contract_version: '1.0.0',
  picture_template: 'https://http2.mlstatic.com/D_{square}_NP_{id}-{size}.webp',
  picture_size_default: 'W',
  url_prefix: 'https://',
  type: isMobile ? 'list' : 'grid',
  picture_square_default: 'NQ',
  url_fragments_default: '#polycard_client=recommendations',
  url_params_default: '',
});
